"use client";
import { Link } from "@/i18n/routing";
import { cn } from "@/lib/utils/utils";
import DynamicIcon from "./dynamicIcon";
import useLocalizer from "@/hooks/useLocalizer";
import { Button } from "../ui/button";
import { useTransition } from "react";
interface FlatButtonsListProps {
  links: {
    href: string;
    label?: string;
    iconName?: string;
    className?: string;
    isWatch?: boolean;
  }[];
  className?: string;
}
export default function FlatButtonsList({
  links,
  className,
}: FlatButtonsListProps) {
  const { isRtl } = useLocalizer();
  const [isPending, startTransition] = useTransition();
  return (
    <div
      className={cn(
        "fixed z-9999 flex flex-col",
        isRtl ? "left-4" : "right-4",
        className,
      )}
    >
      {links.map((link, index) => {
        if (link?.isWatch) {
          return (
            <Button
              key={index}
              disabled={isPending}
              onClick={() => {
                try {
                  window.open(link.href, "_blank");
                  startTransition(async () => {
                    await fetch(`/api/track-click`, {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                      },
                    });
                  });
                } catch (error) {
                  console.error(error);
                }
              }}
              aria-label={link.label}
              variant="none"
              className={cn(
                "flex items-center justify-center gap-2 rounded-none h-16 w-16",
                link?.className,
              )}
            >
              <DynamicIcon name={link.iconName ?? ""} size={24} />
            </Button>
          );
        }
        return (
          <Link
            key={index}
            href={link.href}
            aria-label={link.label}
            target={"_blank"}
            className={cn(
              "flex items-center justify-center gap-2 rouned-full h-16 w-16 ",
              link?.className,
            )}
          >
            <DynamicIcon name={link.iconName ?? ""} size={24} />
          </Link>
        );
      })}
    </div>
  );
}
